import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import TransferOrganizationAccountBlockData from '../../../Models/Content/TransferOrganizationAccountBlockData';
import TransferOrganizationAccountMain from './TransferOrganizationAccountMain';

export default class TransferOrganizationAccountBlock extends EpiComponent<TransferOrganizationAccountBlockData> {
    public render(): ReactNode | ReactNodeArray | null {
      return (
          <TransferOrganizationAccountMain iContent={this.props.data}/>
      )
    }
}
